/* template */
<template><Popup :show="(value)" position="bottom" @close="onClose"><div class="title"><span>{{title}}</span><mpx-view @tap="onClose" class="close-icon"></mpx-view></div><div class="tab-container" v-if="(fuzzy)"><Tab :tabList="(tabList)" :tabKey="(dateType)" @settabkey="setTabkey"/></div><Calendar :class="({visible:dateType === 'exact' })" :type="(type)" :title="('')" :value="(calendarDate)" @confirm="onConfirm" :minDate="(minDate)" :maxDate="(maxDate)" :maxRange="(maxRange)" :bizType="(bizType)" :subTexts="(subTexts)" class="tab-content"/><FuzzySelectDate :class="({visible:dateType === 'fuzzy' })" :fuzzyDate="(fuzzyDate)" @confirm="onFuzzyConfirm" class="tab-content"/></Popup></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mdece9006"}'>
.tab-container
  overflow hidden
  background-color #fff
.tab-content
  position absolute
  visibility hidden
  z-index -1
  &.visible
    position static
    visibility visible
.title
  display flex
  align-items center
  justify-content center
  height 60px
  position relative
  color #000
  font-family PingFang SC
  font-weight 500
  font-size 18px
  background-color #fff
  border-radius 16px 16px 0 0
  .close-icon
    width 50px
    height 50px
    position absolute
    top 3px
    right 0
    background-size 24px 24px
    background-position center
    background-image url('https://ut-static.udache.com/webx/sfc/EQbJIaPUtU4WMcMPFzTPU_clipboard_image_1701312649516.png')
    background-repeat no-repeat
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mdece9006"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexdece9006%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexdece9006%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mdece9006"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexdece9006/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'FuzzySelectDate':getComponent(require("./fuzzy-select-date.mpx?isComponent&outputPath=components%2Ffuzzy-select-date3b2a36c7%2Findex")),'Popup':getComponent(require("../../../node_modules/@didi/spring-ui/ts-popup/index.mpx?isComponent&outputPath=components%2Findex0ce21716%2Findex")),'Calendar':getComponent(require("../../../node_modules/@didi/spring-ui/calendar/index.mpx?isComponent&outputPath=components%2Findex664bbfd5%2Findex")),'Tab':getComponent(require("../../../node_modules/@didi/spring-ui/tab/index.mpx?isComponent&outputPath=components%2Findex504b069c%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
